export const getPersistState = (state) => ({
	sections: state.sections,
	menu: state.menu,
	institutions: state.institutions,
	moviesList: state.moviesList,
	genresList: state.genresList,
	freeVodPackets: state.freeVodPackets,
	wcag_accessibility: state.wcag_accessibility
});
